export const SUB_ROUTE_EXPORT_ID = 'sub-route';

export const SUB_ROUTE_TITLE = 'Rutas';

export const LOCALIZED_PROPERTIES = {
  externalKeys: 'Código',
  name: 'Nombre',
  mainCollaborator: 'Usuario',
  company: 'Compañía',
  responsibleBusinessPartner: 'Responsable',
  routeCode: 'Código Territorio',
  routes: 'Territorio',
  routeAreaCode: 'Código Área Ruta',
  routeAreas:'Áreas de Ruta',
  type: 'Tipo',
  statusId: 'Estado',
};
